module.exports = __webpack_public_path__ + "img/trois-battants.dac38e4.svg";